// models/produtos/Grupo.js
import { ImagemGrupo } from './ImagemGrupo';

export class Grupo {
    constructor(id = 0, descricao = '', vendeApp = false, orderNum = "", inativo = false, imagemGrupoId = null, imagemGrupo = null, cashBackPercent = null) {
        this.id = id;
        this.descricao = descricao;
        this.vendeApp = vendeApp;
        this.orderNum = orderNum;
        this.inativo = inativo;
        this.imagemGrupoId = imagemGrupoId;
        this.imagemGrupo = imagemGrupo || new ImagemGrupo();
        this.cashBackPercent = cashBackPercent;
    }
}
